import React from 'react'
import MaterialSymbol from '../material-symbol'

const MenuOpen = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="menu_open" {...props} />
))

MenuOpen.displayName = 'MenuOpen'

export default MenuOpen
